import React from 'react'

const Checkbox = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.999959" y="0.666585" width="12.6667" height="12.6667" rx="6.33333" fill="#6F00FF" />
      <rect x="0.999959" y="0.666585" width="12.6667" height="12.6667" rx="6.33333" stroke="#6F00FF" stroke-width="0.666667" />
      <g clip-path="url(#clip0_254_5494)">
        <path d="M10.4444 4.6665L6.16661 8.94428L4.22217 6.99984" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_254_5494">
          <rect width="9.33333" height="9.33333" fill="white" transform="translate(2.66663 2.33325)" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default Checkbox